import { defineComponent as _defineComponent } from 'vue'
import ArchivedIcon from "@/components/ArchivedIcon.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import ProfileSubModuleChips from "@/components/profile/ProfileSubModuleChips.vue";
import { BriefcaseItem, SearchItem } from "@/types";
import { getCurrentInstance, reactive } from "vue";
import { useProfile } from "@/composition/useProfile";

interface Props {
  briefcaseView?: boolean;
  searchItem: SearchItem | BriefcaseItem;
  displaySummary?: boolean;
  selectionEnabled?: boolean;
  selectionMode?: number;
  source?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileCard',
  props: {
    briefcaseView: { type: Boolean, default: false },
    searchItem: null,
    displaySummary: { type: Boolean, default: true },
    selectionEnabled: { type: Boolean, default: false },
    selectionMode: { default: -1 },
    source: { default: "" }
  },
  emits: ["profile-selected"],
  setup(__props: any, { emit }) {

const props = __props as { briefcaseView: boolean, searchItem: SearchItem | BriefcaseItem, displaySummary: boolean, selectionEnabled: boolean, selectionMode: number, source: string };


const instance = getCurrentInstance();


const {
  expanded,
  profileClickSelection,
  profileClickEnabled,
  removeFromBriefcaseFolder,
  isAddedToBriefcase,
  toggleBriefcase,
  toggle,
  profileRoute,
  isWebUser,
} = useProfile(
  reactive({
    searchItem: props.searchItem,
    source: props.source ?? "",
    selectionEnabled: props.selectionEnabled ?? false,
    selectionMode: props.selectionMode ?? -1,
    briefcaseView: props.briefcaseView ?? false,
    displaySummary: props.displaySummary ?? true,
    forceUpdate:
      instance?.proxy?.$forceUpdate ??
      (() => {
        return;
      }),
    emit,
  })
);

return { __sfc: true,props, instance, emit, expanded, profileClickSelection, profileClickEnabled, removeFromBriefcaseFolder, isAddedToBriefcase, toggleBriefcase, toggle, profileRoute, isWebUser, ArchivedIcon, NjBtn, ProfileSubModuleChips }
}

})